import { render } from "./ImagePreviewer.vue?vue&type=template&id=3fa77024&scoped=true"
import script from "./ImagePreviewer.vue?vue&type=script&lang=js"
export * from "./ImagePreviewer.vue?vue&type=script&lang=js"

import "./ImagePreviewer.vue?vue&type=style&index=0&id=3fa77024&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa77024"]])

export default __exports__